import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';
import { useTranslation } from 'react-i18next';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import { MetaCampaignData } from '../../../../../../../api/services/mediaPlanning/bookMeta';
import { formatNumberWithSpaces } from '../../../../common/BudgetTable/utils/formatNumberWithSpaces';

export interface MetaPredictionsTableProps {
  pricingData: MetaCampaignData;
}

function BookingStatusTable({ pricingData }: MetaPredictionsTableProps) {
  const { t } = useTranslation();
  return (
    <Table>
      <TableHead>
        <TableCell />
        <TableCell>Previous</TableCell>
        <TableCell>Current</TableCell>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell>
            {t('mediaPlanning.metaBooking.modals.validityCheck.budget')}
          </TableCell>
          <TableCell>
            {`${formatNumberWithSpaces(
              pricingData.value?.existingPredictionData?.budget
            )}` ?? '-'}
          </TableCell>
          <TableCell>
            {`${formatNumberWithSpaces(
              pricingData.value?.reservedPredictionData?.budget
            )}` ?? '-'}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            {t('mediaPlanning.metaBooking.modals.validityCheck.impressions')}
          </TableCell>
          <TableCell>
            {formatNumberWithSpaces(
              pricingData.value?.existingPredictionData?.impressions
            ) ?? '-'}
          </TableCell>
          <TableCell>
            {formatNumberWithSpaces(
              pricingData.value?.reservedPredictionData?.impressions
            ) ?? '-'}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            {t('mediaPlanning.metaBooking.modals.validityCheck.reach')}
          </TableCell>
          <TableCell>
            {formatNumberWithSpaces(
              pricingData.value?.existingPredictionData?.reach
            ) ?? '-'}
          </TableCell>
          <TableCell>
            {formatNumberWithSpaces(
              pricingData.value?.reservedPredictionData?.reach
            ) ?? '-'}
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
}

export default BookingStatusTable;
